import React from "react";
import Navbar from "./Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GetPost from "./GetPost";
import SendPost from "./SendPost";
import Modifypost from "./Modifypost";
import DeletePost from "./DeletePost";
import SearchPost from "./SearchPost";
import HomePage from "./HomePage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar /> {/* Navbar is rendered only once here */}
        <Routes>
          <Route path="/get" Component={GetPost} />
          <Route path="create" Component={SendPost} />
          <Route path="update" Component={Modifypost} />
          <Route path="delete" Component={DeletePost} />
          <Route path="search" Component={SearchPost} />
          <Route path="HomePage" Component={HomePage} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
